import { Box, Typography } from '@mui/material';
import React from 'react';
import { type ProjectTile } from '../../types/project';
import routes from '../../helpers/routes';
import { useStyles } from './SimilarProjects.styles';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';
import ProjectCard from '../ExploreLatestProjects/ProjectCard';

interface SimilarProjectsProps {
  title?: string;
  description: string;
  similarProjects: ProjectTile[];
}

const SimilarProjects = ({
  title,
  description,
  similarProjects,
}: SimilarProjectsProps) => {
  const classes = useStyles();

  return (
    <Box my={4} className={classes.container}>
      <Box mx={4} className={classes.headingContainer}>
        <Typography className={classes.heading} variant="h3">
          {title}
        </Typography>
        {description && (
          <Typography className={classes.description}>{description}</Typography>
        )}
      </Box>
      <Box className={classes.scrollContainer}>
        <Box className={classes.cardsContainer}>
          {similarProjects.slice(0, 4).map((p) => (
            <AnalyticsWrappedComponent
              key={`similar-project-${p.id}`}
              componentType="a"
              eventText="Clicked Project"
              eventLabel={`Search Results - Similar Projects - ${title}`}
              additionalEventProperties={{
                Name: p.title,
                Slug: p.primarySlug,
              }}
              data-track-click={`Similar Project, Navigation, ${p.title}`}
              href={routes.projects(p)}
              rel="noreferrer"
              target="_blank"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                cursor: 'pointer',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
              }}
            >
              <ProjectCard project={p} />
            </AnalyticsWrappedComponent>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SimilarProjects;
